<template>
  <div class="conte">
    <div class="imgs">
      <h3>商品图片：</h3>
      <div class="imgs_box">
        <img :src="ItemData.imag" alt="" />
        <img :src="ItemData.image" alt="" />
        <img :src="ItemData.images" alt="" v-if="ItemData.images != 'undefined'" />
      </div>
    </div>
    <div class="contents">
      <h3>商品描述:</h3>
      <div class="contents_details">
        <table width="100%" border="1">
          <tr>
            <td>商品创建时间</td>
            <td>{{ ItemData.createTime }}</td>

            <td>物品名称</td>
            <td><input type="text" v-model="ItemData.text" class="det" /></td>

            <td>物品描述</td>
            <td><input type="text" v-model="ItemData.textt" class="det" /></td>
          </tr>
          <tr>
            <td>物品规格</td>
            <td><input type="text" v-model="ItemData.specification" class="det" /></td>

            <td>断当票号</td>
            <td><input type="text" v-model="ItemData.ticketNum" class="det" /></td>

            <td>重量/g</td>
            <td><input type="text" v-model="ItemData.weight" class="det" /></td>
          </tr>
          <tr>
            <td>价格</td>
            <td><input type="text" v-model="ItemData.prick" class="det" />元</td>

            <td>销售状态</td>
            <td>{{ ItemData.ismarket == true ? "在售" : "下架" }}</td>

            <td>商品id</td>
            <td>{{ ItemData._id }}</td>
          </tr>
        </table>
      </div>
    </div>

    <div class="sub_xg">
      <el-button type="primary" @click="submitData">提交修改</el-button>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
export default {
  name: "ItemDetail",
  data() {
    return {
      ACCESS_TOKEN: "",
      username: "", //当前登录的用户
    };
  },
  props: ["ItemData"],

  methods: {
    //提交修改
    submitData() {
      this.$confirm("是否提交修改", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.sendData(this.ItemData._id);
          //日志
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消修改",
          });
        });
    },
    //提交修改数据
    sendData(id) {
      this.axios
        .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("shop_hd").doc("${id}").update({data:{
          text:"${this.ItemData.text}",
          textt:"${this.ItemData.textt}",
          specification:"${this.ItemData.specification}",
          ticketNum:"${this.ItemData.ticketNum}",
          weight:"${this.ItemData.weight}",
          prick:"${this.ItemData.prick}",
          }})`,
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            this.AddLogs();
            this.$emit("change", true);
            this.$message({
              type: "success",
              message: "修改成功!",
            });
            return;
          }
          this.$message({
            type: "info",
            message: "修改失败" + res.data.errmsg,
          });
        });
    },
    //提交日志
    AddLogs() {
      this.axios.post("/api/tcb/databaseadd?access_token=" + this.ACCESS_TOKEN, {
        env: `${this.userData.env}`,
        query: `db.collection("logs").add({data:{price:"${
          this.ItemData.prick
        }",createDate:"${dayjs().format("YYYY-MM-DD HH:mm:ss")}",content:"${
          this.ItemData.text
        }",action:"修改商品",username:"${this.username}"}})`,
      });
    },
  },
  created() {
    this.getTokens();
    //获取当前登录的用户数据
    this.getUserToken();
  },
  mounted() {
    setTimeout(() => {
      this.username = this.userData.username;
    }, 800);
  },
};
</script>
<style scoped>
.imgs_box {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.imgs_box img {
  width: 250px;
  height: 250px;
}
.contents_details {
  display: flex;
  flex-direction: column;
}
table {
  border-collapse: collapse;
}
td input {
  border: none;
}
.det {
  color: brown;
}
.sub_xg {
  margin-top: 20px;
}
</style>
